(function() {
    'use strict';
    var CandidateExternalIdentifierCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, xmsNotificationFactory) {
        $scope.ngModel = passedModel;
        $scope.candidateExternalIdentifier = {};

        $scope.ajaxCallList = function(ajaxUrl, data) {
            var errorMsg = 'Error';
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.ngModel.smartTableRefreshCounter++;
                    xmsNotificationFactory.addObj({id: "candExtIdentifierPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.ngModel);
                },
                function(result) {
                    $scope.ngModel.htmlOutput = $sce.trustAsHtml(errorMsg);
                }
            );
        }

        $scope.externalIdentifierSave = function($event, closePop, controllerName, actionName) {

            var isValid = this.popupForm.$valid;
            if(isValid){
                $event.preventDefault();
                var data = $('#popupForm').serialize();
                var ajaxUrl = WEBAPP_PATH + "/"+controllerName+"/"+actionName;
                $scope.ajaxCallList(ajaxUrl , data);
            }
        }

        $scope.closePop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }
    };

    CandidateExternalIdentifierCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params','xmsNotificationFactory'];
    angular.module('app').controller('CandidateExternalIdentifierCtrl', CandidateExternalIdentifierCtrl);
}());